var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.component)?_c(_vm.component,{tag:"component"}):_vm._e(),_c('div',{staticClass:"m_join"},[_c('button',{staticClass:"mj_btn",on:{"click":function($event){return _vm.openAlert()}}},[_vm._v("가입승인")]),_c('button',{staticClass:"mj_btn"},[_vm._v("가입거절")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }